<template>
  <div
    v-if="isActive"
    v-scroll-lock="isActive"
    class="modal active"
  >
    <div class="modal-overlay"></div>

    <section class="modal-container office-select-session">
      <header class="modal-header office-select-session__header">
        <h2 class="office-select-session__title">
          Escolha abaixo o consultório que você deseja gerenciar:
        </h2>
      </header>

      <article class="modal-body office-select-session__body">
        <div
          v-click-outside="() => showList = false"
          class="office-select-session__select"
        >
          <div
            class="office-select-session__select-chosen"
            @click="showList = !showList"
          >
            <span v-if="!chosenOfficeId">Lista de consultórios</span>
            <span v-if="chosenOfficeId">
              {{ offices.find((office) => office.id === chosenOfficeId).name }}
            </span>

            <i
              :class="showList && 'office-select-session__select-icon--reverse'"
              class="icon icon-arrow-down office-select-session__select-icon"
            />
          </div>

          <transition name="fade">
            <ul
              v-if="showList"
              class="office-select-session__select-list"
            >
              <li
                v-for="office in offices.filter(o => /facetoface/gi.test(o.type))"
                :key="`doctor-office-${office.id}`"
                :class="
                  (chosenOfficeId === office.id) &&
                  'office-select-session__select-list-item--selected'
                "
                class="office-select-session__select-list-item"
                @click="
                  chosenOfficeId = office.id;
                  showList = false;
                "
              >
                <span>{{ office.name }}</span>

                <i
                  v-if="chosenOfficeId === office.id"
                  class="icon icon-check"
                />
              </li>
            </ul>
          </transition>
        </div>

        <div class="office-select-session__check">
          <label class="form-checkbox">
            <input
              v-model="savePreferences"
              type="checkbox"
            />

            <i class="form-icon" />

            <span>Salvar preferências</span>
          </label>
        </div>
      </article>

      <footer class="modal-footer office-select-session__footer">
        <button
          class="btn btn-primary office-select-session__btn"
          :disabled="!chosenOfficeId"
          @click="saveDefaultOffice()"
        >
          <span>Continuar</span>
        </button>
      </footer>
    </section>
  </div>
</template>

<script>
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'DrOfficeSelectSession',

  data () {
    return {
      isActive: false,
      showList: false,
      defaultOfficeId: null,
      chosenOfficeId: null,
      sessionOfficeId: null,
      savePreferences: false
    }
  },

  computed: {
    ...mapGetters({
      offices: 'getOffices'
    })
  },

  mounted () {
    EventBus.$on('show-office-select-session', this.init)
  },

  methods: {
    init () {
      if (this.offices.length > 0) {
        this.sessionOfficeId = parseInt(localStorage.getItem('sessionOfficeId')) || null
        this.defaultOfficeId = parseInt(localStorage.getItem('defaultOfficeId')) || null
        this.showModalSelectOffice()
        return
      }

      EventBus.$emit('show-premium-remaining-days')
    },

    showModalSelectOffice () {
      if (this.sessionOfficeId) {
        this.setCurrentOffice(this.sessionOfficeId)
        return
      }

      if (
        this.defaultOfficeId &&
        this.offices.some(o => o.id === this.defaultOfficeId) &&
        !this.sessionOfficeId
      ) {
        this.setCurrentOffice(this.defaultOfficeId)
        return
      }

      const facetofaceOffices = this.offices
        .filter(o => /facetoface/gi.test(o.type))

      if (
        this.offices.length > 1 &&
        !this.sessionOfficeId &&
        !this.defaultOfficeId &&
        facetofaceOffices.length > 1
      ) {
        this.isActive = true
        return
      }

      this.setCurrentOffice(this.offices[0].id)
    },

    saveDefaultOffice () {
      if (this.savePreferences) {
        localStorage.setItem('defaultOfficeId', this.chosenOfficeId)
      } else {
        localStorage.removeItem('defaultOfficeId')
      }

      localStorage.setItem('sessionOfficeId', this.chosenOfficeId)
      this.setCurrentOffice(this.chosenOfficeId)
      this.isActive = false
    },

    setCurrentOffice (id) {
      this.$store.dispatch('setCurrentOffice', id)
      EventBus.$emit('show-premium-remaining-days')
    }
  }
}
</script>
